/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ComputeOpportunityScoreRequest
 */
export interface ComputeOpportunityScoreRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ComputeOpportunityScoreRequest
     */
    advancedSearchIds: Array<string>;
}

/**
 * Check if a given object implements the ComputeOpportunityScoreRequest interface.
 */
export function instanceOfComputeOpportunityScoreRequest(value: object): value is ComputeOpportunityScoreRequest {
    if (!('advancedSearchIds' in value) || value['advancedSearchIds'] === undefined) return false;
    return true;
}

export function ComputeOpportunityScoreRequestFromJSON(json: any): ComputeOpportunityScoreRequest {
    return ComputeOpportunityScoreRequestFromJSONTyped(json, false);
}

export function ComputeOpportunityScoreRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComputeOpportunityScoreRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'advancedSearchIds': json['advancedSearchIds'],
    };
}

export function ComputeOpportunityScoreRequestToJSON(value?: ComputeOpportunityScoreRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'advancedSearchIds': value['advancedSearchIds'],
    };
}

